import { FC } from 'react'
import { Accordion, AccordionItem } from '@nextui-org/react'
import DOMPurify from 'isomorphic-dompurify'
import parse from 'html-react-parser'

interface FAQItem {
  faqItem: {
    value: {
      id: string
      data: {
        question: string
        answer: string
      }
    }
  }
}

interface FAQItemsSliderProps {
  faqItems: FAQItem[]
}

const itemClasses = {
  content: 'mb-5 text-[21px] md:text-[24px]',
  title:
    'py-1 pl-1 text-[22px] md:text-[24px] font-bold font-[raleway] font-bold text-pl-dark',
}

const FAQAccordion: FC<FAQItemsSliderProps> = ({ faqItems }) => {
  if (!faqItems.length) return null

  return (
    <Accordion itemClasses={itemClasses}>
      {faqItems.map((faq, index) => {
        if (!faq.faqItem.value?.data) return null

        return (
          <AccordionItem
            key={`${faq.faqItem.value.id || 'item'}-${index}`}
            aria-label={faq.faqItem.value.data?.question}
            title={faq.faqItem.value.data?.question}
            className="faq-accordion-item"
          >
            {parse(DOMPurify.sanitize(faq.faqItem.value.data?.answer))}
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}

export default FAQAccordion
